import { render, staticRenderFns } from "./Despesa.vue?vue&type=template&id=1d06e605"
import script from "./Despesa.vue?vue&type=script&lang=js"
export * from "./Despesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports